import { render, staticRenderFns } from "./Urun.vue?vue&type=template&id=d6bca776&scoped=true&"
import script from "./Urun.vue?vue&type=script&lang=js&"
export * from "./Urun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6bca776",
  null
  
)

export default component.exports